
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academic/[universityIdName]/degree/[degreeIdName]",
      function () {
        return require("private-next-pages/academic/[universityIdName]/degree/[degreeIdName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academic/[universityIdName]/degree/[degreeIdName]"])
      });
    }
  